import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayNext = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.75 15.29c.41 0 .75.32.75.71v7.97L17.68 16c0-.4.33-.71.75-.71.41 0 .75.32.75.71a1.45 1.45 0 0 1-.65 1.18L6.34 25.15a1.55 1.55 0 0 1-2.13-.44 1.38 1.38 0 0 1-.22-.74V16c0-.4.34-.71.75-.71Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.75 16.83c.41 0 .75-.32.75-.71V8.14l12.18 7.98c0 .39.33.71.75.71.41 0 .75-.32.75-.71a1.45 1.45 0 0 0-.65-1.18L6.34 6.97a1.55 1.55 0 0 0-2.13.43c-.15.23-.22.48-.22.74v7.98c0 .39.34.71.75.71ZM24.25 7.43a.73.73 0 0 0-.75.71v15.72c0 .4.34.71.75.71h1.5c.41 0 .75-.32.75-.71V8.14c0-.4-.34-.71-.75-.71h-1.5ZM22 8.14C22 6.96 23 6 24.25 6h1.5A2.2 2.2 0 0 1 28 8.14v15.72c0 1.18-1 2.14-2.25 2.14h-1.5A2.2 2.2 0 0 1 22 23.86V8.14Z"
	})]
});
export { SvgPlayNext as ReactComponent };
